module.exports = __webpack_public_path__ + "img/ship.f1d86741.svg";